export class EvalancheForm {

  constructor(instance) {
    this.instance = instance;
    this.form = this.instance.querySelector('.tx-evalanche-form');
    this.requiredFields = this.form.querySelectorAll('[required]');
    this.validationFields = this.form.querySelectorAll('[data-validate]');

    this.initShowButton();
    this.requiredHandler();
    this.setTrackingValues();
    this.submitHandler();
  }

  submitHandler() {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (this.validationFields.length > 0) {
        if (!this.isFormValid()) {
          this.scrollToFormStart();
          return false;
        }
      }

      this.sendForm();
    })
  }

  requiredHandler() {
    if (this.requiredFields.length > 0) {
      this.requiredFields.forEach(field => {
        field.addEventListener('invalid', (event) => {
          this.hideValidationError(field);
          if (!this.isFieldFilled(field)) {
            this.showValidationError(field);
          }
        });
        field.addEventListener('change', (event) => {
          this.hideValidationError(field);
        });
      });
    }
  }

  setTrackingValues() {
    let leadSourceOriginal = this.form.querySelector('input[name="form_LEADSOURCEORIGINAL"]');
    if (leadSourceOriginal) {
      leadSourceOriginal.value = this.getUrlParameterValue('lso')
    }

    let leadSourceMostRecent = this.form.querySelector('input[name="form_LEADSOURCEMOSTRECENT"]');
    if (leadSourceMostRecent) {
      leadSourceMostRecent.value = this.getUrlParameterValue('lso')
    }

    let utmSource = this.form.querySelector('input[name="form_UTM_SOURCE"]');
    if (utmSource) {
      utmSource.value = this.getUrlParameterValue('utm_source')
    }

    let utmMedium = this.form.querySelector('input[name="form_UTM_MEDIUM"]');
    if (utmMedium) {
      utmMedium.value = this.getUrlParameterValue('utm_medium')
    }

    let utmCampaign = this.form.querySelector('input[name="form_UTM_CAMPAIGN"]');
    if (utmCampaign) {
      utmCampaign.value = this.getUrlParameterValue('utm_campaign')
    }

    let utmContent = this.form.querySelector('input[name="form_UTM_CONTENT"]');
    if (utmContent) {
      utmContent.value = this.getUrlParameterValue('utm_content')
    }
  }

  getUrlParameterValue(parameter) {
    let query = decodeURIComponent(window.location.search.substring(1));
    let availableParameters = query.split('&');
    let parameterName;
    let i;
    let value = null;

    for (i = 0; i < availableParameters.length; i++) {
      parameterName = availableParameters[i].split('=');
      if (parameterName[0] === parameter) {
        value = parameterName[1] === null ? null : parameterName[1];
      }
    }

    return value;
  }

  isFormValid() {
    let state = true;

    if (this.validationFields.length > 0) {
      this.validationFields.forEach(field => {
        this.hideValidationError(field);
        if (!this.isFieldValid(field)) {
          this.showValidationError(field);
          state = false;
        }
      });
    }

    return state;
  }

  isFieldValid(field) {
    let state;

    switch (field.dataset.validate) {
      case 'email':
        state = this.emailValidator(field.value);
        break;
      default:
        // not defined case is valid
        state = true;
        break;
    }

    return state
  }

  isFieldFilled(field) {
    let state;

    if (field.required) {
      switch (field.type) {
        case 'checkbox':
        case 'radio':
          state = field.checked;
          break;
        default:
          state = field.value !== '';
          break;
      }
    }

    return state;
  }

  emailValidator(string) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(string);
  }

  hideValidationError(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      field.parentElement.querySelector('span').classList.remove('tx-evalanche-form__invalid-field');
    } else {
      if (field.classList.contains('tx-evalanche-form__invalid-field')) {
        field.classList.remove('tx-evalanche-form__invalid-field');
        let errorMessage = field.parentElement.querySelector('.tx-evalanche-form__validation-error');
        if (errorMessage) {
          errorMessage.remove();
        }
      }
    }
  }

  showValidationError(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      field.parentElement.querySelector('span').classList.add('tx-evalanche-form__invalid-field');
    } else {
      if (field.dataset.validateError) {
        let errorMessage = document.createElement('p');
        errorMessage.innerHTML = field.dataset.validateError;
        errorMessage.classList.add('tx-evalanche-form__validation-error');
        field.after(errorMessage);
      }

      field.classList.add('tx-evalanche-form__invalid-field');
    }
  }

  scrollToFormStart() {
    location.href = '#' + this.form.id;
  }

  sendForm() {
    this.form.classList.add('tx-evalanche-form--sending');

    fetch(this.form.action, {
      method: 'POST',
      body: new FormData(this.form)
    }).then(response => {
      this.form.parentElement.querySelector('.tx-evalanche-form__success').style.display = 'block';
      this.form.remove();
      this.scrollToInstance();
    }).catch(error => {
      this.form.classList.remove('tx-evalanche-form--sending');
    });
  }

  initShowButton() {
    let button = this.instance.querySelector('.tx-evalanche-form-show-button');
    if (button) {
      button.addEventListener('click', () => {
        this.form.style.display = 'block';
        button.style.display = 'none';
      });
    }
  }

  scrollToInstance() {
    const y = this.instance.getBoundingClientRect().top + window.scrollY;
    window.scroll(0, y);
  }
}

let forms = document.querySelectorAll('.tx-evalanche-forms__instance');
if (forms.length > 0) {
  forms.forEach(form => {
    new EvalancheForm(form);
  });
}
